import { Link } from "react-router-dom";
import React from "react";
import { useLocation } from "react-router-dom";

export function NavLink({...props}) {
    const location = useLocation();
    const isActive = location.pathname === props.to;
    var className = props.responsive ? "" : "nav-item";
    className += isActive ? ' active' : '';
    className.trim();

    return (
        <Link to={props.to} className={className} {...props}>
            {props.children}
        </Link>
    );
}
